import { css } from 'linaria';

export const adressWrap = css`
  margin-bottom: var(--space-150);
`;

export const subwayWrap = css`
  margin-bottom: var(--space-400);
`;

export const transportHeading = css`
  margin-bottom: var(--space-100);
`;

export const howToGetToWrap = css`
  display: block;
  white-space: break-spaces;
  overflow-wrap: break-word;
`;

export const modalStyle = css`
  overflow-y: auto;
`;
